module.exports = __webpack_public_path__ + "static/media/rib.ac72c38d.png";